<template>
  <v-flex xs12>
    <v-layout
      row
      nowrap
      mb-1
      :class="{'mt-3': $vuetify.breakpoint.xsOnly && !forSummary }"
    >
      <v-flex
        xs12
        sm10
        :class="['align-center',{'mt-3': $vuetify.breakpoint.xsOnly && !forSummary, 'd-none': !showEditFields, 'elevation-2 md6': !forSummary, 'md5': forSummary, 'separator': forSummary && $vuetify.breakpoint.mdAndUp}]"
      >
        <v-layout row px-4 wrap>
          <v-flex
            xs12
            pb-2
            mt-3
            class="label"
          >
            {{ $t('message.bizgainOnboarding.logo') }}
          </v-flex>
          <image-picker
            :items="logos"
            :type="imageTypes.logo"
            :loader="hasLogoChanged"
            :selected-template-id="id"
            :disabled="hasLogoChanged"
            @update="updateLogo"
            @uploadedLogos="addLogos"
            @image-process="processImage"
            :is-lead-image="false"
          />
          <v-flex
            xs12
            pb-2
            mt-3
            class="label"
          >
            {{ $t('message.bizgainOnboarding.photo') }}
          </v-flex>
          <image-picker
            :items="creativeLeadImages"
            :type="imageTypes.lead"
            :loader="hasPhotoChanged"
            :disabled="hasPhotoChanged"
            :selected-template-id="id"
            @update="selectLeadImage"
            @add="addLeadImage"
            @image-process="processImage"
            :is-lead-image="true"
          />
          <v-flex
            xs12
            pb-2
            mt-3
            class="label"
          >
            {{ $t('message.bizgainOnboarding.primaryColor') }}
          </v-flex>
          <v-flex
            xs12
          >
            <v-layout
              class="input-border justify-space-between"
              :class="'color-picker-container'"
              @click=" colorPicker.show()"
            >
              <v-flex
                class="shrink"
                pl-1
                my-1
              >
                <div
                  class="color-picker"
                  :id="'color-picker'"
                  :style="{ 'background-color': color }"
                />
              </v-flex>
              <v-flex
                xs5
                sm4
                md5
                py-1
                class="color-picker-code body-1"
                :class="{'pl-3': $vuetify.breakpoint.xsOnly, 'ml-2': $vuetify.breakpoint.smAndUp, 'ml-1': $vuetify.breakpoint.mdOnly, 'ml-4': $vuetify.breakpoint.lgAndUp}"
              >
                <span class="truncate"> {{ textTruncate(color, 20) }} </span>
              </v-flex>
              <v-divider
                :class="{'ml-1': $vuetify.breakpoint.xsOnly, 'ml-2': $vuetify.breakpoint.smAndUp}"
                inset
                vertical
              />
              <v-layout
                align-center
                justify-center
                :class="{'pr-3 ml-1': $vuetify.breakpoint.xsAndDown, 'mr-4': $vuetify.breakpoint.smAndDown, 'pr-0': $vuetify.breakpoint.smAndUp, 'pr-4': $vuetify.breakpoint.mdAndUp, 'pr-4': $vuetify.breakpoint.lgAndUp}"
              >
                <v-flex
                  xs6
                  sm7
                  md6
                  class="mr-2"
                >
                  <span
                    flat
                    solo
                    v-ripple="false"
                    class="no-background-hover pa-0 modal-text"
                  >
                    <v-icon :color="'primary'" dense>
                      palette
                    </v-icon>
                    <span class="pl-1 pr-3" :class="'text-primary'">
                      {{ $t('message.bizgainOnboarding.change') }}
                    </span></span>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            pt-2
          >
            <v-layout row wrap>
              <v-flex
                shrink
                class="caption align-center grey--text"
              >
                {{ $t('message.bizgainOnboarding.suggestedColors') }}
              </v-flex>
              <v-flex
                v-for="(palette, index) in editedBusinessDetails.creativeDetail.templates.find(t=>t.id == template.id).suggestedColorPalettes"
                :key="index"
                shrink
                class="d-flex"
              >
                <v-btn
                  :ripple="false"
                  class="palette-color px-0 mx-1"
                  :color="palette.primaryColor"
                  fab
                  icon
                  :class="{'palette-outline':palette.primaryColor.toLowerCase() === color.toLowerCase()}"
                  small
                  @click="colorPicker.setColor(palette.primaryColor)"
                />
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex
            xs12
            pb-2
            mt-3
            class="label"
          >
            {{ $t('message.bizgainOnboarding.primaryText') }}
          </v-flex>
          <v-flex
            xs12
          >
            <v-layout
              mb-1
              pa-0
              row
              wrap
            >
              <v-flex>
                <custom-text-field
                  :name="'primaryText'"
                  :validation="'required|max:30'"
                  :classes="'ma-0 pb-1 pa-0 body-1'"
                  v-model="primaryText"
                  :counter="'30'"
                  :error-messages="$t('message.bizgainOnboarding.primaryTextValidationMessage')"
                  :icon="isShortenFlow ? 'mdi-check' : ''"
                >
                  <template v-if="hasPrimaryTextChanged" v-slot:appendedSlot>
                    <v-progress-circular
                      class="mr-1 pb-1"
                      indeterminate
                      size="25"
                      width="2"
                      color="primary"
                    />
                  </template>
                </custom-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
          />
          <v-flex
            xs12
            pb-2
            class="label"
            v-if="!hideCallToAction"
          >
            {{ $t('message.bizgainOnboarding.callToAction') }}
          </v-flex>
          <v-flex
            xs12
            v-if="!hideCallToAction"
          >
            <v-layout
              mb-1
              pa-0
              row
              wrap
            >
              <v-flex>
                <custom-text-field
                  :name="'callToAction'"
                  :validation="'required|max:15'"
                  :classes="'ma-0 pb-1 pa-0 body-1'"
                  v-model="callToAction"
                  :counter="'15'"
                  :error-messages="$t('message.bizgainOnboarding.callToActionValidationMessage')"
                  :icon="isShortenFlow ? 'mdi-check' : ''"
                >
                  <template v-if="hasCallToActionChanged" v-slot:appendedSlot>
                    <v-progress-circular
                      class="mr-1 pb-1"
                      indeterminate
                      size="25"
                      width="2"
                      color="primary"
                    />
                  </template>
                </custom-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        xs12
        sm10
        md7
        :class="['align-center', {'elevation-2 md6': !forSummary}, {'md7': forSummary}, 'mt-1', 'px-2', {'d-none': !showCreative}]"
      >
        <creative-preview
          :extracted-creative-details="extractedCreativeDetails"
          :template="template"
          @on-image-load-started="toggleNextButton(true)"
          @on-image-load-finished="toggleNextButton(false)"
        />
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
import {
  VLayout,
  VFlex,
  VBtn,
  VProgressCircular,
  VIcon,
  VDivider
} from 'vuetify/lib';
import CreativePreview from '../../imageCreativesCreativePreview/components/CreativePreview';
import '../../../js/pickr.min.js';
import '../../../css/pickr.nano.min.css';
import { mapGetters, mapActions } from 'vuex';
import { textTruncate } from 'Helpers/helpers';
import ImagePicker from './ImagePicker';
import { imageTypes, bizgainOnboardingRoutes, objectiveType, onboardingSections, subsequentFlowSteps, signupFlowSteps } from 'Features/bizgainOnboarding/constants';
import { extractCreativeDetails } from '../../../helpers/templateHelper';
import uuidv4 from 'uuid/v4';
import debounce from 'lodash/debounce';
import CustomTextField from '../../../../../components/Input/CustomTextField.vue';
import { toCustomTitleCase } from 'Features/bizgainOnboarding/helpers/textCaseConvertHelper';
export default {
  async created() {
    if(this.isShortenFlow){
      this.setCurrentSection(onboardingSections.signup);
      if(this.isInAppCampaign){
        this.setCurrentRoute(bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.name);
        this.setSubsequentSteps(subsequentFlowSteps);
      }
      else{
        this.setCurrentRoute(bizgainOnboardingRoutes.ImageCreativesCreativeEdit.name);
        this.setSignUpSteps(signupFlowSteps);
      }
    }
    else{
      this.setCurrentSection(onboardingSections.CREATIVE);
      if(this.isInAppCampaign){
        this.setCurrentRoute(bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.name);
      }
      else{
        if(!this.forSummary){
          this.setCurrentRoute(bizgainOnboardingRoutes.ImageCreativesCreativeEdit.name);
        }
      }
    }
    this.template = this.editedBusinessDetails.creativeDetail.templates.find((x) => x.id == this.id);
    let creativeDetail = this.editedBusinessDetails.creativeDetail;
    if (this.creativeLogos && Object.entries(this.creativeLogos).length == 0) {
      let uniqueId = uuidv4();
      let logoItem = {
        id: this.template.id,
        type: imageTypes.logo,
        name: this.template.logo.url.split('/').pop(),
        url: this.template.logo.url,
        suggestedColorPalettes: this.template.suggestedColorPalettes,
        selectedColorPalette: this.template.colorPalette,
        width: this.template.logo.dimension.width,
        height: this.template.logo.dimension.height,
        uniqueId,
        originalLogoDetails: this.editedBusinessDetails.logoDetails
      };
      this.$nextTick(async () => {
        await this.addLogos(logoItem);
      })
    }
    if (Array.isArray(this.creativeLeadImages) && this.creativeLeadImages.length == 0) {
      let leadImages = creativeDetail.templates.map(template => {
        return {
          id: template.id,
          type: imageTypes.lead,
          name: template.leadImage.url.split('/').pop(),
          url: template.leadImage.url
        }
      })
      this.$nextTick(() => {
        this.setLeadImages(leadImages);
      })
    }
    this.extractedCreativeDetails = extractCreativeDetails(this.editedBusinessDetails);
  },
  props: {
    editedBusinessDetails: {
      default: null,
      type: Object
    },
    showEditFields: {
      type: Boolean,
      default: true
    },
    showCreative: {
      type: Boolean,
      default: true
    },
    forSummary: {
      type: Boolean,
      default: false
    }
  },
  destroyed () {
    window.removeEventListener('wheel', this.hideColorPicker);
  },
  data() {
    return {
      template: null,
      settingsY: {
        suppressScrollX: true
      },
      active: 0,
      textTruncate,
      color: this.$vuetify.theme.white,
      colorPicker: null,
      imageTypes,
      isUpdated: false,
      extractedCreativeDetails: null,
      updateCreativeDebounced: null,
      setColorDebounced: null,
      isImageLoading: false,
      bizgainOnboardingRoutes,
      objectiveType
    };
  },
  mounted() {
    this.color = this.editedBusinessDetails.creativeDetail.templates.find((x) => x.id == this.template.id).colorPalette.primaryColor;
    this.colorPicker = Pickr.create({
      el: '#color-picker',
      theme: 'nano',
      useAsButton: true,
      position: 'right-start',
      lockOpacity: true,
      default: this.color,
      components: {
        // Main components
        preview: true,
        opacity: true,
        hue: true,

        // Input / output Options
        interaction: {
          hex: true,
          hsla: false,
          hsva: false,
          cmyk: false,
          input: true,
          clear: false,
          save: false
        }
      }
    });
    this.colorPicker.on('change', (color, instance) => {
      if(this.setColorDebounced){
        this.setColorDebounced.cancel();
      }
      if(this.color !== color.toHEXA().toString()){
        this.setColorDebounced = debounce(function(){
          this.color = color.toHEXA().toString();
          this.editedBusinessDetails.creativeDetail.templates.find((x) => x.id == this.template.id).colorPalette.primaryColor = this.color;
        }, 250);
        this.setColorDebounced();
      }
    });
    this.colorPicker.on('show', (color, instance) => {
      /*
          Post tab switch - when user clicks / when color picker is re-initialized the dialog position is not re-computed correctly,
          below code will re-compute and assign the position based on the original library implementation
          Reference: https://github.com/Simonwep/pickr/blob/master/src/js/pickr.js
      */
      let colorPickerDialog = instance._root.app;
      let colorPickeButton = document.querySelector('.color-picker');
      if(colorPickeButton){
        const cb = colorPickeButton.getBoundingClientRect();
        colorPickerDialog.style.top = `${(cb.top)}px`;
        colorPickerDialog.style.left = `${(cb.left + 30)}px`;
      }
    })
    window.addEventListener('wheel', this.hideColorPicker, true);
  },
  methods: {
    ...mapActions([
      'setCurrentSection',
      'setCurrentRoute',
      'addCreativeLogo',
      'addCreativeLeadImage',
      'patchBusinessDetails',
      'updateCreativeLoader',
      'updateBusinessDetails',
      'clearCreativeImages',
      'setIsCreativeEdited',
      'updateMessage',
      'setSubsequentSteps',
      'setSignUpSteps'
    ]),
    hideColorPicker () {
      /*
          Post tab switch - On scroll the dialog position values which are updated to correct values are overrided by
          the library constructor to the position values which is incorrect, due to which on scroll dialog is
          repositioned to page's top left, hiding the element to prevent this behaviour.
          Note: There is a prop in the library which does the same thing but there is some noticeable delay
          Reference: https://github.com/Simonwep/pickr/blob/master/src/js/pickr.js
      */
      this.colorPicker.hide();
    },
    async addLogos(item) {
      let creativeLogos = JSON.parse(JSON.stringify(this.creativeLogos));
      if (item) {
        let logoDetail = {
          id: item.id,
          image: {
            height: item.height,
            name: item.name,
            uniqueId: item.uniqueId,
            url: item.url,
            width: item.width,
            type: item.type
          },
          originalLogoDetails: item.originalLogoDetails,
          selectedColorPalette: item.selectedColorPalette,
          suggestedColorPalettes: item.suggestedColorPalettes
        };
        if (creativeLogos[logoDetail.id]) {
          creativeLogos[logoDetail.id].unshift(logoDetail);
        } else {
          creativeLogos[logoDetail.id] = [];
          creativeLogos[logoDetail.id].unshift(logoDetail);
        }
        this.updateLogoDetails(logoDetail.image, logoDetail.id);
        this.updateCreativeDetail(item);
      }
      this.addCreativeLogo(creativeLogos);
    },
    processImage(value){
      this.$emit('isBtnDisabled', value);
    },
    setLeadImages(items) {
      let leadImages = JSON.parse(JSON.stringify(this.creativeLeadImages));
      for (let i = 0; i < items.length; i++) {
        let existingLeadImage = leadImages.find(cli => cli.name === items[i].name);
        if (!existingLeadImage) {
          leadImages.unshift(items[i]);
        }
      }
      this.addCreativeLeadImage(leadImages);
    },
    async addLeadImage(item) {
      this.setLeadImages([item]);
      this.editedBusinessDetails.creativeDetail.templates.find(template => template.id == this.template.id).leadImage.url = item.url;
      this.$emit('updateLeadImage', item);
      await this.updateLeadImage(item);
    },
    async updateLogo(item){
      let creativeLogos = this.creativeLogos;
      this.updateCreativeLoader({ logo: true });

      let selectedCreativeLogo;
      // eslint-disable-next-line no-unused-vars
      for(const [key, value] of Object.entries(creativeLogos)) {
        selectedCreativeLogo = value.find(x => x.image.uniqueId == item.uniqueId);
        if (selectedCreativeLogo && selectedCreativeLogo.image) {
          this.updateLogoDetails(selectedCreativeLogo.image, selectedCreativeLogo.id);
        }
      }
      this.updateCreativeDetail(selectedCreativeLogo);
    },
    async updateLogoDetails(item, creativeId) {
      let businessCreativeTemplate = this.editedBusinessDetails.creativeDetail.templates.find(x => x.id == creativeId);
      if (businessCreativeTemplate) {
        businessCreativeTemplate.logo.url = item.url;
        businessCreativeTemplate.logo.dimension.height = item.height;
        businessCreativeTemplate.logo.dimension.width = item.width;
      }
    },
    updateCreativeDetail(item) {
      if (!item.originalLogoDetails.url.includes('PlaceHolderBusinessLogo')){
        this.editedBusinessDetails.isBusinessLogoAvailable = true;
      }
      this.editedBusinessDetails.logoDetails = item.originalLogoDetails;
      this.editedBusinessDetails.creativeDetail.suggestedColorPalettes = item.suggestedColorPalettes;
      this.editedBusinessDetails.creativeDetail.selectedColorPalette = item.selectedColorPalette;
      this.editedBusinessDetails.creativeDetail.templates.find(template => template.id == item.id).colorPalette = item.selectedColorPalette;
      this.editedBusinessDetails.creativeDetail.templates.find(template => template.id == item.id).suggestedColorPalettes = item.suggestedColorPalettes;
      this.colorPicker.setColor(item.selectedColorPalette.primaryColor);
      this.extractedCreativeDetails = extractCreativeDetails(this.editedBusinessDetails);
    },
    async selectLeadImage(item){
      this.updateCreativeLoader({ photo: true });
      await this.updateLeadImage(item);
      this.$emit('updateLeadImage', item);
    },
    async updateLeadImage(item) {
      let businessCreativeTemplates = this.editedBusinessDetails.creativeDetail.templates;
      businessCreativeTemplates.find(temp=>temp.id == this.id).leadImage.url = item.url;
    },
    toggleNextButton(status){
      const delay = status ? 0 : 200;
      setTimeout(() => {
        this.isImageLoading = status;
      }, delay);
    },
    toCustomTitleCase
  },
  computed: {
    ...mapGetters(['isInAppCampaign', 'isCreativeEdited', 'creativeLogos', 'creativeLeadImages', 'businessDetails', 'creativeLoader', 'objective', 'roimaticConfiguration']),
    hasPrimaryTextChanged(){
      return this.creativeLoader && this.creativeLoader.hasOwnProperty('primaryText');
    },
    hasCallToActionChanged(){
      return this.creativeLoader && this.creativeLoader.hasOwnProperty('callToAction');
    },
    hasLogoChanged(){
      return this.creativeLoader && this.creativeLoader.hasOwnProperty('logo');
    },
    hasPhotoChanged(){
      return this.creativeLoader && this.creativeLoader.hasOwnProperty('photo');
    },
    isBtnDisabled() {
      return this.hasPrimaryTextChanged || this.hasCallToActionChanged || this.hasLogoChanged || this.hasPhotoChanged || (this.showCreative && this.isImageLoading) || this.errors.items.length > 0
    },
    id() {
      return this.$route.params.id ? this.$route.params.id : this.businessDetails.creativeDetail.selectedTemplateId;
    },
    selectedTemplate() {
      return this.businessDetails.creativeDetail.templates.find(x => x.id == this.id);
    },
    primaryText: {
      get() {
        return this.editedBusinessDetails.creativeDetail.templates.find(x => x.id == this.template.id).adDetail.displayAd.primaryText;
      },
      set: debounce(function(value) {
        this.editedBusinessDetails.creativeDetail.templates.find(x => x.id == this.template.id).adDetail.displayAd.primaryText = toCustomTitleCase(value);
        this.updateCreativeLoader({ primaryText: true });
      }, 800)
    },
    callToAction: {
      get() {
        return this.editedBusinessDetails.creativeDetail.templates.find(x => x.id == this.template.id).adDetail.callToAction;
      },
      set: debounce(function(value) {
        this.editedBusinessDetails.creativeDetail.templates.find(x => x.id == this.template.id).adDetail.callToAction = toCustomTitleCase(value);
        this.updateCreativeLoader({ callToAction: true });
      }, 1000)
    },
    logos() {
      if (this.creativeLogos && Array.isArray(this.creativeLogos[this.id]) && this.creativeLogos[this.id].length > 0) {
        return this.creativeLogos[this.id].map(x => x.image);
      }
      return [];
    },
    isCallsObjective(){
      return this.objective === this.objectiveType.calls.id;
    },
    hideCallToAction(){
      return this.isCallsObjective && (this.template.type === 9 || this.template.type === 10);
    },
    isShortenFlow(){
      if(this.businessDetails && this.businessDetails.shortenFlow){
        return true;
      }
      else if(this.roimaticConfiguration && this.roimaticConfiguration.shortenFlow){
        return true;
      }
      return false;
    }
  },
  watch: {
    isBtnDisabled(value){
      this.$emit('isBtnDisabled', value);
    }
  },
  components: {
    VLayout,
    VFlex,
    CreativePreview,
    VBtn,
    ImagePicker,
    VProgressCircular,
    VIcon,
    VDivider,
    CustomTextField
  }
};
</script>
<style lang="scss" scoped>
.color-picker-container{
  cursor: pointer;
}

.color-picker-container-disabled{
  cursor: not-allowed !important;
  pointer-events: none;
}

.color-picker {
  height: 35px;
  width: 35px;
  cursor: inherit !important
}

.color-picker-code{
  line-height: 2.5;
}

.palette-color {
  height: 20px !important;
  width: 20px !important;
  box-shadow: none !important;
}

.palette-outline{
    border: 2px solid var(--v-primary-base) !important;
}

.color-picker-btn{
    height: auto !important;
    justify-self: right;
    width: fit-content;
    min-width:fit-content !important;
}

::v-deep .input-border{
  border-radius: 4px;
  border: solid 0.5px var(--v-black-base);
  white-space: nowrap !important;
  overflow-x: auto !important;
  scrollbar-width: thin;
}

.text-primary {
    color: var(--v-primary-base);
}

.modal-text{
  font-size: 14px !important;
}

.truncate{
  overflow: hidden;
  max-width: 20ch;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.separator{
 border-right: 1px solid #aaaaaa;
}
</style>
